import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {InvoicesFilter} from '../components/invoices-filter/InvoicesFilter';
import {InvoicesTable} from '../components/invoices-table/InvoicesTable';
import {InvoicesFooter} from '../components/invoices-footer/InvoicesFooter';
import FooterBar from '../../_common/components/FooterBar';

export function InvoicesCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'invoices-list-card'}>
      <InvoicesFilter/>
      <InvoicesTable/>
      <FooterBar>
        <InvoicesFooter/>
      </FooterBar>
    </Card>
  );
}
